import React from "react";
import AdBanner from "./AdBanner";

export default function Contact() {
  return (
    <section id="contact">
      <h2>İletişim</h2>
      
      {/* Advertisement */}
      <AdBanner
        imageSrc="/ad_celenk_gayrimenkul2.JPG"
        altText="Çelenk Gayrimenkul 2 Reklamı"
        companyName="Çelenk Gayrimenkul - Emlak Danışmanlığı"
        link="#"
        className="horizontal"
      />
      
      <div className="contact-info">
        <div className="contact-item">
          <strong>📧 E-posta:</strong>
          <a href="mailto:info@karbeyazgyo.com">info@karbeyazgyo.com</a>
        </div>
        <div className="contact-item">
          <strong>📱 Telefon:</strong>
          <a href="tel:+905441859899">0544 185 9899</a>
        </div>
        <div className="contact-item">
          <strong>🌐 Web:</strong>
          <span>www.parkguven.com</span>
        </div>
      </div>
      
      {/* Another Advertisement */}
      <AdBanner
        imageSrc="/ad_simge_bilgisayar.JPG"
        altText="Simge Bilgisayar Reklamı"
        companyName="Simge Bilgisayar - Teknoloji Çözümleri"
        link="#"
        className="horizontal"
      />
    </section>
  );
}
